export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20artistic%20background%20with%20deep%20crimson%20red%20and%20warm%20charcoal%20tones%2C%20subtle%20geometric%20shapes%20and%20textured%20brush%20strokes%2C%20editorial%20magazine%20style%2C%20intense%20atmospheric%20mood%2C%20no%20people%2C%20clean%20composition%20with%20ample%20negative%20space%20on%20the%20right%20side%20for%20text%20overlay%2C%20cinematic%20lighting%20with%20radial%20gradient%20fade%20from%20bottom%20left&width=1800&height=1200&seq=hero-bg-911-v2&orientation=landscape"
          alt="911黑料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 pb-8 md:pb-12">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs font-semibold mb-4 md:mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              实时更新 · 独家爆料
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-3 md:mb-4">
              911黑料网
              <br className="md:hidden" />
              <span className="text-accent-400"> · 全网第一吃瓜阵地</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 font-medium mb-2 md:mb-3">
              深挖娱乐圈不为人知的真相，做最懂吃瓜群众的爆料平台
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-6 md:mb-8">
              911黑料网汇聚全网最热门的娱乐爆料资讯，覆盖明星八卦、综艺内幕、影视黑幕、
              行业潜规则等全领域。每日更新超过200条独家内容，500+一线爆料人实时供稿，
              让你第一时间掌握娱乐圈的风吹草动。这里是吃瓜群众的终极阵地，
              所有的劲爆猛料，都在这里首发。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-1.5 text-white/80">
                <span className="text-lg md:text-xl font-bold text-accent-400">15万+</span>
                <span className="text-xs md:text-sm">独家爆料</span>
              </div>
              <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
              <div className="flex items-center gap-1.5 text-white/80">
                <span className="text-lg md:text-xl font-bold text-accent-400">日更200+</span>
                <span className="text-xs md:text-sm">条内容</span>
              </div>
              <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
              <div className="flex items-center gap-1.5 text-white/80">
                <span className="text-lg md:text-xl font-bold text-accent-400">7×24h</span>
                <span className="text-xs md:text-sm">全天候更新</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }}
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-flashlight-line mr-1.5"></i>查看最新猛料
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
                className="w-full sm:w-auto px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold text-sm rounded-md border border-white/20 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-mail-send-line mr-1.5"></i>匿名投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end pb-8 md:pb-12">
            <div className="relative w-full max-w-[420px] md:max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20illustration%20of%20breaking%20news%20and%20investigative%20journalism%20concept%2C%20warm%20crimson%20red%20and%20dark%20charcoal%20color%20palette%2C%20abstract%20newspaper%20fragments%20and%20magnifying%20glass%20elements%2C%20dramatic%20contrast%20lighting%2C%20sophisticated%20magazine%20cover%20style%2C%20no%20text%2C%20minimalist%20yet%20impactful%20composition&width=960&height=720&seq=hero-visual-911-v2&orientation=landscape"
                alt="911黑料网独家爆料"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-primary-500/90 rounded text-xs font-bold text-white">
                今日更新 36条
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}